export function Capitalize(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export function Truncate(str: string, length: number, ending?: string): string {
    if (ending === undefined) {
        ending = '...';
    }

    if (str.length <= length) {
        return str;
    }

    return str.substr(0, length - ending.length) + ending;
}

export function Plural(str: string, count: number) {
    return `${str}${count === 1 || count === -1 ? '' : 's'}`;
}
